'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__ from "date-fns";
import * as __WEBPACK_EXTERNAL_MODULE_react_day_picker_locale_cb9285fc__ from "react-day-picker/locale";
import * as __WEBPACK_EXTERNAL_MODULE_react_day_picker_7bc423fd__ from "react-day-picker";
import * as __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__ from "../../../utils/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Providers_DayMapProvider_js_af4ff9e1__ from "../Providers/DayMapProvider.js";
import * as __WEBPACK_EXTERNAL_MODULE__CustomComponents_HeatMapDayButton_js_57474cfe__ from "../CustomComponents/HeatMapDayButton.js";
import * as __WEBPACK_EXTERNAL_MODULE__CustomComponents_MonthButtons_js_105a1d5d__ from "../CustomComponents/MonthButtons.js";
import * as __WEBPACK_EXTERNAL_MODULE__Calendar_variants_js_1207bdc2__ from "./Calendar.variants.js";
const DEFAULT_TIMEZONE = 'America/Toronto';
function Calendar({ mode = 'single', numberOfMonths = 1, captionLayout = 'label', selected, handleCalendarChange, min, max, startMonth, endMonth, className, isMobile, timeZone = DEFAULT_TIMEZONE, components: customComponents, dayMap, ...restProps }) {
    const [selectedDates, setSelectedDates] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(selected);
    const handleSelect = (value)=>{
        setSelectedDates(value);
        handleCalendarChange(value);
    };
    const styles = (0, __WEBPACK_EXTERNAL_MODULE__Calendar_variants_js_1207bdc2__.calendarVariants)({
        isMobile,
        isDayMap: !!(null == dayMap ? void 0 : dayMap.data)
    });
    const classNames = {
        root: (0, __WEBPACK_EXTERNAL_MODULE__utils_index_js_02c78a7f__.cn)(className, [
            styles.root()
        ]),
        month_caption: styles.monthCaption(),
        button_previous: styles.buttonPrevious(),
        button_next: styles.buttonNext(),
        caption_label: styles.captionLabel(),
        nav: styles.nav(),
        months: styles.months(),
        month: styles.month(),
        weekdays: styles.weekdays(),
        week_row: styles.weekRow(),
        week_header: styles.weekHeader(),
        day: styles.day(),
        day_button: styles.dayButton(),
        selected: styles.selectedDays(),
        today: styles.today(),
        outside: styles.outsideDay(),
        weeks: styles.weeks(),
        week: styles.week(),
        weekday: styles.weekday(),
        week_number: styles.weekNumber(),
        chevron: styles.chevron(),
        month_grid: styles.monthGrid(),
        range_start: styles.rangeStart(),
        range_middle: styles.rangeMiddle(),
        range_end: styles.rangeEnd(),
        disabled: styles.disabled(),
        hidden: styles.hidden()
    };
    const props = {
        mode,
        classNames,
        formatters: {
            formatWeekdayName: (weekday, options)=>(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(weekday, 'ccc', options)
        },
        min,
        max,
        numberOfMonths,
        startMonth,
        endMonth,
        locale: __WEBPACK_EXTERNAL_MODULE_react_day_picker_locale_cb9285fc__.enUS,
        timeZone,
        captionLayout,
        components: {
            NextMonthButton: __WEBPACK_EXTERNAL_MODULE__CustomComponents_MonthButtons_js_105a1d5d__.NextMonthButton,
            PreviousMonthButton: __WEBPACK_EXTERNAL_MODULE__CustomComponents_MonthButtons_js_105a1d5d__.PreviousMonthButton,
            DayButton: __WEBPACK_EXTERNAL_MODULE__CustomComponents_HeatMapDayButton_js_57474cfe__.HeatMapDayButton,
            ...customComponents
        },
        fixedWeeks: !isMobile,
        selected: selectedDates,
        onSelect: handleSelect,
        hideNavigation: !!isMobile,
        footer: (null == customComponents ? void 0 : customComponents.Footer) ? 'Footer' : null,
        ...restProps
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Providers_DayMapProvider_js_af4ff9e1__.DayMapProvider, {
        dayMap: dayMap,
        mode: mode,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_day_picker_7bc423fd__.DayPicker, {
            ...props
        })
    });
}
export { Calendar };
